import { Component, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SecretKeyQrislyResponse } from 'src/app/types/response/webhook-response.type';

@Component({
  standalone: false,
  selector: 'app-modal-generate-config',
  templateUrl: './modal-generate-config.component.html',
  styleUrl: './modal-generate-config.component.scss'
})
export class ModalGenerateConfigComponent implements OnChanges {
  @Input() isVisible: boolean = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Input() secretKeyData: SecretKeyQrislyResponse | null = null;
  @Output() secretKeyDataChange = new EventEmitter<SecretKeyQrislyResponse | null>();

  userId = signal<string>('');
  secretKey = signal<string>('');

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['secretKeyData'] && this.secretKeyData) {
      this.userId.set(this.secretKeyData.user_uuid);
      this.secretKey.set(this.secretKeyData.secret_key);
    }
  }

  isVisibleInfo: boolean = true;
  isSaved: boolean = false;

  constructor(
    private message: NzMessageService
  ) {
  }

  onModalClose() {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.isSaved = false;
    this.isVisibleInfo = true;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.message.success('Copied to clipboard');
  }
}
